// Canonical industry catalog for Mi6 AIP — a manufacturing-only platform.
// Display order matches the dropdown order presented to reps. The legacy
// pan-B2B taxonomy was removed on 2026-05-12 per founder direction: AIP's
// question bank, templates, and coaching are built for industrial / hardgoods
// manufacturers, and reps should not be able to pick non-manufacturing
// categories that the platform cannot serve.

export const INDUSTRY_OPTIONS = [
  "Industrial Manufacturing",
  "Automotive",
  "Aerospace & Defense",
  "Energy / Utilities",
  "Consumer Goods Manufacturing",
  "Building Products / Construction Materials",
  "Metals & Mining",
  "Chemicals & Plastics",
  "Food & Beverage Manufacturing",
] as const;

export type IndustryOption = (typeof INDUSTRY_OPTIONS)[number];

export const DEFAULT_INDUSTRY: IndustryOption = "Industrial Manufacturing";
